module.exports = __webpack_public_path__ + "img/Cathy.2f4b314b.png";